import createIcon from '../../createIcon';

/**
 * @component @name LocalParking
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNSAzSDUuNVYyMUg5LjVWMTVIMTIuNUMxNS44MSAxNSAxOC41IDEyLjMxIDE4LjUgOUMxOC41IDUuNjkgMTUuODEgMyAxMi41IDNaTTEyLjcgMTFIOS41VjdIMTIuN0MxMy44IDcgMTQuNyA3LjkgMTQuNyA5QzE0LjcgMTAuMSAxMy44IDExIDEyLjcgMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalParking = createIcon('LocalParking', [
  [
    'path',
    {
      d: 'M12.5 3H5.5V21H9.5V15H12.5C15.81 15 18.5 12.31 18.5 9C18.5 5.69 15.81 3 12.5 3ZM12.7 11H9.5V7H12.7C13.8 7 14.7 7.9 14.7 9C14.7 10.1 13.8 11 12.7 11Z',
      key: '1rogh7',
    },
  ],
]);

export default LocalParking;
